import { DollarsSchema } from '@mntn-dev/domain-types'

export const convertCentsToDollars = (val: number) => {
  return DollarsSchema().parse(val / 100)
}
